import type { CoreErrorApi } from '@ingenico/api-sdk-core/common';

export class CoreError extends Error {
  readonly status: number;
  readonly data: CoreErrorApi;

  constructor(message: string, status: number, data: CoreErrorApi) {
    super(message);
    this.name = 'CoreError';
    this.status = status;
    this.data = data;
  }
}
